const VARIABLE_PATTERN = /{{[^}]+}}/;
const DYNAMIC_HEADER_FORMATS = ['DOCUMENT', 'IMAGE', 'VIDEO', 'LOCATION'];

const findBodyComponent = template =>
  template?.components?.find(component => component.type === 'BODY');

const containsTemplateVariables = value => {
  if (typeof value === 'string') {
    return VARIABLE_PATTERN.test(value);
  }

  if (Array.isArray(value)) {
    return value.some(item => containsTemplateVariables(item));
  }

  if (value && typeof value === 'object') {
    return Object.values(value).some(item => containsTemplateVariables(item));
  }

  return false;
};

const headerRequiresParameters = component =>
  component?.type === 'HEADER' &&
  DYNAMIC_HEADER_FORMATS.includes(component?.format);

export const serializeAutoReplyTemplateConfig = template => {
  if (!template) {
    return {};
  }

  return {
    name: template.name || '',
    namespace: template.namespace || '',
    language: template.language || '',
    category: template.category || '',
  };
};

export const getAutoReplyTemplateKey = template => {
  const name = template?.name || '';
  const language = template?.language || '';

  return [name, language].filter(Boolean).join('::');
};

export const getAutoReplyTemplateLabel = template => {
  const name = template?.name || '';
  const language = template?.language || '';

  return language ? `${name} (${language})` : name;
};

export const getAutoReplyTemplatePreview = template =>
  findBodyComponent(template)?.text || '';

export const isAutoReplyEligibleWhatsAppTemplate = template => {
  if (!template?.name) {
    return false;
  }

  if (template?.status?.toLowerCase() !== 'approved') {
    return false;
  }

  if ((template?.category || '').toUpperCase() === 'AUTHENTICATION') {
    return false;
  }

  if (template.name.startsWith('customer_satisfaction_survey')) {
    return false;
  }

  const components = Array.isArray(template.components) ? template.components : [];
  if (!components.length) {
    return false;
  }

  return !components.some(component => {
    return (
      headerRequiresParameters(component) ||
      containsTemplateVariables(component)
    );
  });
};

export const buildAutoReplyTemplateOption = template => ({
  value: getAutoReplyTemplateKey(template),
  label: getAutoReplyTemplateLabel(template),
});

export const buildAutoReplyTemplateOptions = templates =>
  (templates || [])
    .filter(isAutoReplyEligibleWhatsAppTemplate)
    .sort((left, right) =>
      getAutoReplyTemplateLabel(left).localeCompare(
        getAutoReplyTemplateLabel(right)
      )
    )
    .map(buildAutoReplyTemplateOption);

export const findAutoReplyTemplateByKey = (templates, key) =>
  (templates || []).find(template => getAutoReplyTemplateKey(template) === key);

export const findAutoReplyTemplateByConfig = (templates, templateConfig) =>
  findAutoReplyTemplateByKey(
    templates,
    getAutoReplyTemplateKey(templateConfig || {})
  );
